import { ROUTES } from "@/routes_new";
import { Link } from "react-router-dom";
import LogoDark from "@/assets/images/allears-dark.svg";
import LogoLight from "@/assets/images/allears-light.svg";
import { useLingui } from "@lingui/react/macro";

export default function Logo({
  className,
  width = 60,
}: {
  className?: string;
  width?: number;
}) {
  const { t } = useLingui();

  return (
    <Link to={ROUTES.APP_HOME} className={className}>
      <LogoDark
        width={width}
        alt={t`All Ears Logotyp`}
        className="dark:hidden"
      />
      <LogoLight
        width={width}
        alt={t`All Ears Logotyp`}
        className="hidden dark:block"
      />
    </Link>
  );
}
